import { getBorderGradient, hexToRgb } from "rainowls-shared";

/** One choice supplies the selection border and its coordinated action color. */
export function selectionAppearance(style: "solid" | "gradient", solid: string, gradientId: string) {
  const gradient = getBorderGradient(gradientId);
  const accent = style === "solid" ? solid : gradient.accent;
  const direction = gradient.direction === "diagonal" ? "135deg" : "90deg";
  const foreground = "#FFFFFF";
  const { r, g, b } = hexToRgb(accent);
  return {
    border: style === "solid"
      ? `linear-gradient(${solid}, ${solid})`
      : `linear-gradient(${direction}, ${gradient.colors.join(", ")})`,
    accent,
    foreground,
    rgb: `${r}, ${g}, ${b}`,
  };
}
